import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";

import CommonLayout from "./components/CommonLayout/CommonLayout.js";
import Login from "./components/Login/Login.jsx";

// School Components
import SchoolAllChapter from "./components/School/SchoolChapters/SchoolAllChapter/SchoolAllChapter.jsx";
import SchoolChapter from "./components/School/SchoolChapters/SchoolChapter/SchoolChapter.jsx";
import SchoolAllClass from "./components/School/SchoolClass/SchoolAllClass/SchoolAllClasses.jsx";
import SchoolEditClass from "./components/School/SchoolClass/SchoolEditClass/SchoolEditClass.jsx";
import SchoolAddClass from "./components/School/SchoolClass/SchoolNewClass/SchoolNewClass.jsx";
import SchoolAddSubject from "./components/School/SchoolSubjects/SchoolAddSubject/AddSubject.jsx";
import SchoolAllSubject from "./components/School/SchoolSubjects/SchoolAllSubject/AllSubject.jsx";

// University Components
import UniversityAllCourse from "./components/University/UniversityCourses/UniversityAllCourses/UniversityAllCourses.jsx";
import UniversityCourse from "./components/University/UniversityCourses/UniversityCourse/UniversityCourse.jsx";
import UniversitySemesterCreate from "./components/University/UniversitySemesters/UniversitySemesterCreate/UniversitySemesterCreate.jsx";
import UniversitySemesterTable from "./components/University/UniversitySemesters/UniversitySemesterTable/UniversitySemesterTable.jsx";
import UniversitySubjectCreate from "./components/University/UniversitySubject/UniversitySubjectCreate/UniversitySubjectCreate.jsx";
import UniversitySubjectTable from "./components/University/UniversitySubject/UniversitySubjectTable/UniversitySubjectTable.jsx";

//CE Components
import CEAddCompetitiveSubject from "./components/CompetitiveExam/CompetitiveSubject/AddCompetitiveSubject/AddCompetitiveSubject.jsx";
import CEAllCompetitiveSubject from "./components/CompetitiveExam/CompetitiveSubject/AllCompetitiveSubject/AllCompetitiveSubject.jsx";
import CEAddTopics from "./components/CompetitiveExam/CompetitiveTopics/AddTopic/AddTopics.jsx";
import CEAllTopics from "./components/CompetitiveExam/CompetitiveTopics/AllTopics/AllTopics.jsx";
import CEAddExamCategory from "./components/CompetitiveExam/ExamCategory/AddExamCategory/AddExamCategory.jsx";
import CEAllExamCategory from "./components/CompetitiveExam/ExamCategory/AllExamCaterory/AllExamCategory.jsx";

import StudentAllDetails from "./components/Student/HomeTutor/TuitionManagementSystem/StudentAllDetails/StudentAllDetails.jsx";
import TMSshare from "./components/Student/HomeTutor/TuitionManagementSystem/TMSshare/TMSshare.jsx";

//Settings
import Path4uSettings from "./components/Settings/Settings.js";

// Exam Notes
import CourseManagement from "./components/Student/ExamNotes/CourseManagement/CourseManagement.jsx";
import StudentAllNotes from "./components/Student/ExamNotes/StudentAllNotes/StudentAllNotes.jsx";
// _Upload Notes
import UploadAddCollegeNotes from "./components/Student/ExamNotes/UploadNotes/UploadAddCollegeNotes.jsx";
import UploadAllCollegeNotes from "./components/Student/ExamNotes/UploadNotes/UploadAllCollegeNotes.jsx";

import UploadAddCompetitiveNotes from "./components/Student/ExamNotes/UploadNotes/UploadAddCompetitiveNotes.jsx";
import UploadCompetitiveNotes from "./components/Student/ExamNotes/UploadNotes/UploadAllCompetitiveNotes.jsx";

import UploadAllSchoolNotes from "./components/Student/ExamNotes/UploadNotes/AllSchoolNotes.jsx";
import UploadAllNotes from "./components/Student/ExamNotes/UploadNotes/UploadAllNotes.jsx";
import UploadSchoolNotes from "./components/Student/ExamNotes/UploadNotes/UploadSchoolNotes.jsx";

import HomeTutorCourseManagement from "./components/Student/HomeTutor/CourseManagement/HomeTutorCourseManagement.jsx";
import HomeTutorTuitionManagementSystem from "./components/Student/HomeTutor/TuitionManagementSystem/TuitionManagementSystem.jsx";

import UniversityAdd from "./components/University/UniversityCreate/UniversityAdd/UniversityAdd.jsx";
import UniversityAllList from "./components/University/UniversityCreate/UniversityAll/UniversityAllList.jsx";

//Subjective Exam
import SubjectiveExam from "./components/Student/SubjectiveExam/SubjectiveExam.jsx";

// School SE
import SApprovalCE from "./components/Student/SubjectiveExam/SchoolSE/ApprovalCE/ApprovalCE.jsx";
import SApprovalSMTE from "./components/Student/SubjectiveExam/SchoolSE/ApprovalSMTE/ApprovalSMTE.jsx";
import SApprovalUE from "./components/Student/SubjectiveExam/SchoolSE/ApprovalUE/ApprovalUE.jsx";
import SchoolSE from "./components/Student/SubjectiveExam/SchoolSE/SchoolSE.jsx";

// University SE
import UApprovalCE from "./components/Student/SubjectiveExam/UniversitySE/ApprovalCE/ApprovalCE.jsx";
import UApprovalSMTE from "./components/Student/SubjectiveExam/UniversitySE/ApprovalSMTE/ApprovalSMTE.jsx";
import UApprovalUE from "./components/Student/SubjectiveExam/UniversitySE/ApprovalUE/ApprovalUE.jsx";
import UniversitySE from "./components/Student/SubjectiveExam/UniversitySE/UniversitySE.jsx";

//Compititive Exam _Subjective Exam
import CApprovalCE from "./components/Student/SubjectiveExam/CompExamSE/ApprovalCE/ApprovalCE.jsx";
import CApprovalSMTE from "./components/Student/SubjectiveExam/CompExamSE/ApprovalSMTE/ApprovalSMTE.jsx";
import CApprovalUE from "./components/Student/SubjectiveExam/CompExamSE/ApprovalUE/ApprovalUE.jsx";
import CompExamSE from "./components/Student/SubjectiveExam/CompExamSE/CompExamSE.jsx";

// State And City
// state
import State from "./components/StateAndCity/State/AddState/State.jsx";
import AllStates from "./components/StateAndCity/State/AllStates/AllStates.jsx";
import EditState from "./components/StateAndCity/State/EditState/EditState.jsx";
// city
import AllCity from "./components/StateAndCity/City/AllCity/AllCity.jsx";
import City from "./components/StateAndCity/City/AddCity/City.jsx";
import EditCity from "./components/StateAndCity/City/EditCity/EditCity.jsx";

//Student Scholarship
import Logout from "./components/Logout/Logout.jsx";
import Assignment from "./components/Student/Assignment/Assignment.jsx";
import AllAssignmentSchool from "./components/Student/Assignment/AssignmentSchool/AllAssignmentSchool/AllAssignmentSchool.jsx";
import AssignmentSchool from "./components/Student/Assignment/AssignmentSchool/AssignmentSchool.jsx";
import AllAssignmentUniversity from "./components/Student/Assignment/AssignmentUniversity/AllAssignmentUniversity/AllAssignmentUniversity.jsx";
import AssignmentUniversity from "./components/Student/Assignment/AssignmentUniversity/AssignmentUniversity.jsx";
import AllCentalGovScholarship from "./components/Student/StudentScholarship/CentralGovScholarship/AllCentralGovScholarship/AllCentralGovScholarship.jsx";
import CentalGovScholarship from "./components/Student/StudentScholarship/CentralGovScholarship/CentralGovScholarship.jsx";
import AllNGOPrivateGovScholarship from "./components/Student/StudentScholarship/NGOPrivateScholarship/AllNGOPrivateScholarship/AllNGOPrivateScholarship.jsx";
import NGOPrivateGovScholarship from "./components/Student/StudentScholarship/NGOPrivateScholarship/NGOPrivateScholarship.jsx";
import AllStateGovScholarship from "./components/Student/StudentScholarship/StateGovScholarship/AllStateGovScholarship/AllStateGovScholarship.jsx";
import StateGovScholarship from "./components/Student/StudentScholarship/StateGovScholarship/StateGovScholarship.jsx";
import StudentScholarship from "./components/Student/StudentScholarship/StudentScholarship.jsx";

// Choose Career
import ChooseCareer from "./components/Student/ChooseCareer/ChooseCareer.jsx";
import CareerAdd from "./components/Student/ChooseCareer/Career/CareerAdd/CareerAdd.jsx";
import BlogAdd from "./components/Student/ChooseCareer/Blog/BlogAdd/BlogAdd.jsx";
import CareerAll from "./components/Student/ChooseCareer/Career/CareerAll/CareerAll.jsx";
import BlogAll from "./components/Student/ChooseCareer/Blog/BlogAll/BlogAll.jsx";

//Notifications
import PushNotification from "./components/PushNotification/AddNotification/PushNotification.jsx";
import AllPushNotification from "./components/PushNotification/AllPushNotification/AllPushNotification.jsx";
import EditPushNotification from "./components/PushNotification/EditPushNotification/EditPushNotification.jsx";

//Gov Approved Council
import GovApprovedCouncil from "./components/GovApprovedCouncil/AddGovApprovedCouncil/GovApprovedCouncil.jsx";
import AllGovApprovedCouncil from "./components/GovApprovedCouncil/AllGovApprovedCouncil/AllGovApprovedCouncil.jsx";
import EditGovApprovedCouncil from "./components/GovApprovedCouncil/EditGovApprovedCouncil/EditGovApprovedCouncil.jsx";

// Profiles
import StudentsProfile from "./components/Student/StrudentsProfile/StudentsProfile.jsx";
import TeachersProfile from "./components/Teacher/TeachersProfile/TeachersProfile.jsx";
import StudentsProfileDetails from "./components/Student/StrudentsProfile/StrudentsProfileDetails/StrudentsProfileDetails.jsx";
import TeachersProfileDetails from "./components/Teacher/TeachersProfile/TeacherProfileDetails/TeacherProfileDetails.jsx";
import LiveClassAdd from "./components/LiveClasses/LiveClassAdd/LiveClassAdd.jsx";
import LiveClassAll from "./components/LiveClasses/LiveClassAll/LiveClassAll.jsx";
import LiveClassesPurchase from "./components/LiveClasses/LiveClassesPurchase/LiveClassesPurchase.jsx";
import LiveClassDetail from "./components/LiveClasses/LiveClassDetailPage/LiveClassDetail.jsx";
import LiveClassEdit from "./components/LiveClasses/LiveClassEdit/LiveClassEdit.jsx";
import EditStateGovScholarship from "./components/Student/StudentScholarship/StateGovScholarship/EditStateGovScholarship/EditStateGovScholarship.jsx";
import EditNGOPrivateScholarship from "./components/Student/StudentScholarship/NGOPrivateScholarship/EditNGOPrivateScholarship/EditNGOPrivateScholarship.jsx";
import EditCentralGovScholarship from "./components/Student/StudentScholarship/CentralGovScholarship/EditCentralGovScholarship/EditCentralGovScholarship.jsx";
import UniversityEdit from "./components/University/UniversityCreate/UniversityEdit/UniversityEdit.jsx";
import UniversityEditCourse from "./components/University/UniversityCourses/UniversityEditCourse/UniversityEditCourse.jsx";
import UniversitySemesterEdit from "./components/University/UniversitySemesters/UniversitySemesterEdit/UniversitySemesterEdit.jsx";
import UniversitySubjectEdit from "./components/University/UniversitySubject/UniversitySubjectEdit/UniversitySubjectEdit.jsx";
import SchoolEditSubject from "./components/School/SchoolSubjects/SchoolEditSubject/SchoolEditSubject.jsx";
import EditExamCategory from "./components/CompetitiveExam/ExamCategory/EditExamCategory/EditExamCategory.jsx";
import EditCompetitiveSubject from "./components/CompetitiveExam/CompetitiveSubject/EditCompetitiveSubject/EditCompetitiveSubject.jsx";
import EditSchoolNotes from "./components/Student/ExamNotes/UploadNotes/EditSchoolNotes.jsx";
import EditCollegeNotes from "./components/Student/ExamNotes/UploadNotes/EditCollegeNotes.jsx";
import EditCompetitiveNotes from "./components/Student/ExamNotes/UploadNotes/EditCompetitiveNotes.jsx";
import SlidersAdd from "./components/Sliders/SlidersAdd/SlidersAdd.jsx";
import SlidersAll from "./components/Sliders/SlidersAll/SlidersAll.jsx";
import SlidersEdit from "./components/Sliders/SlidersEdit/SlidersEdit.jsx";
import StudentHomeWorkDetails from "./components/Student/HomeWorkAssistance/HomeWork/StudentHomeWorkDetails.jsx";
import SolutionHomeWork from "./components/Student/HomeWorkAssistance/Solution/SolutionHomeWork.jsx";
import TeacherAssign from "./components/Student/HomeWorkAssistance/HomeWork/TeacherAssign/TeacherAssign.jsx";
import NiosNewClass from "./components/School/Nios/NiosClass/NiosNewClass/NiosNewClass.jsx";
import NiosAllClass from "./components/School/Nios/NiosClass/NiosAllClass/NiosAllClass.jsx";
import NiosEditClass from "./components/School/Nios/NiosClass/NiosEditClass/NiosEditClass.jsx";
import NiosAddSubject from "./components/School/Nios/NiosSubject/NiosAddSubject/NiosAddSubject.jsx";
import NiosAllSubject from "./components/School/Nios/NiosSubject/NiosAllSubject/NiosAllSubject.jsx";
import NiosEditSubject from "./components/School/Nios/NiosSubject/NiosEditSubject/NiosEditSubject.jsx";
import EditAssignmentSchool from "./components/Student/Assignment/AssignmentSchool/EditAssignmentSchool/EditAssignmentSchool.jsx";
import EditAssignmentUniversity from "./components/Student/Assignment/AssignmentUniversity/EditAssignmentUniversity/EditAssignmentUniversity.jsx";
import CareerEdit from "./components/Student/ChooseCareer/Career/CareerEdit/CareerEdit.jsx";
import BlogEdit from "./components/Student/ChooseCareer/Blog/BlogEdit/BlogEdit.jsx";
import AddCoupons from "./components/OfferAndCoupons/AddCoupons/AddCoupons.jsx";
import AllCoupons from "./components/OfferAndCoupons/AllCoupons/AllCoupons.jsx";
import EditCoupons from "./components/OfferAndCoupons/EditCoupons/EditCoupons.jsx";
import AddAppointmentPricing from "./components/Pricing/AppointmentPricing/AddAppointmentPricing/AddAppointmentPricing.jsx";
import AllAppointmentPricing from "./components/Pricing/AppointmentPricing/AllAppointmentPricing/AllAppointmentPricing.jsx";
import EditAppointmentPricing from "./components/Pricing/AppointmentPricing/EditAppointmentPricing/EditAppointmentPricing.jsx";
import AddWalletPricing from "./components/Pricing/WalletPricing/AddWalletPricing/AddWalletPricing.jsx";
import AllWalletPricing from "./components/Pricing/WalletPricing/AllWalletPricing/AllWalletPricing.jsx";
import EditWalletPricing from "./components/Pricing/WalletPricing/EditWalletPricing/EditWalletPricing.jsx";
import AddNiosNotes from "./components/Student/ExamNotes/UploadNotes/niosNotes/AddNiosNotes.jsx";
import AllNiosNotes from "./components/Student/ExamNotes/UploadNotes/niosNotes/AllNiosNotes.jsx";
import EditNiosNotes from "./components/Student/ExamNotes/UploadNotes/niosNotes/EditNiosNotes.jsx";
import AddHomeWorkPricing from "./components/Pricing/HomeWorkPricing/AddHomeWorkPricing/AddHomeWorkPricing.jsx";
import AllHomeWorkPricing from "./components/Pricing/HomeWorkPricing/AllHomeWorkPricing/AllHomeWorkPricing.jsx";
import EditHomeWorkPricing from "./components/Pricing/HomeWorkPricing/EditHomeWorkPricing/EditHomeWorkPricing.jsx";
import ExamNotesPricing from "./components/Pricing/ExamNotesPricing/ExamNotesPricing.jsx";
import AddNiosPricing from "./components/Pricing/ExamNotesPricing/NiosPricing/AddNiosPricing.jsx";
import AllNiosPricing from "./components/Pricing/ExamNotesPricing/NiosPricing/AllNiosPricing.jsx";
import EditNiosPricing from "./components/Pricing/ExamNotesPricing/NiosPricing/EditNiosPricing.jsx";
import AddCompetitionPricing from "./components/Pricing/ExamNotesPricing/CompetitionPricing/AddCompetitionPricing.jsx";
import AllCompetitionPricing from "./components/Pricing/ExamNotesPricing/CompetitionPricing/AllCompetitionPricing.jsx";
import EditCompetitionPricing from "./components/Pricing/ExamNotesPricing/CompetitionPricing/EditCompetitionPricing.jsx";
import AddUniversityPricing from "./components/Pricing/ExamNotesPricing/UniversityPricing/AddUniversityPricing.jsx";
import AllUniversityPricing from "./components/Pricing/ExamNotesPricing/UniversityPricing/AllUniversityPricing.jsx";
import EditUniversityPricing from "./components/Pricing/ExamNotesPricing/UniversityPricing/EditUniversityPricing.jsx";
import SubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/SubjectiveExamPricing.jsx";
import AddSchoolSubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/SchoolSubjectiveExamPricing/AddSchoolSubjectiveExamPricing.jsx";
import AllSchoolSubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/SchoolSubjectiveExamPricing/AllSchoolSubjectiveExamPricing.jsx";
import EditSchoolSubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/SchoolSubjectiveExamPricing/EditSchoolSubjectiveExamPricing.jsx";
import AddUniversitySubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/UniversitySubjectiveExamPricing/AddUniversitySubjectiveExamPricing.jsx";
import AllUniversitySubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/UniversitySubjectiveExamPricing/AllUniversitySubjectiveExamPricing.jsx";
import EditUniversitySubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/UniversitySubjectiveExamPricing/EditUniversitySubjectiveExamPricing.jsx";
import AddCompetitionSubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/CompetitionSubjectiveExamPricing/AddCompetitionSubjectiveExamPricing.jsx";
import AllCompetitionSubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/CompetitionSubjectiveExamPricing/AllCompetitionSubjectiveExamPricing.jsx";
import EditCompetitionSubjectiveExamPricing from "./components/Pricing/SubjectiveExamPricing/CompetitionSubjectiveExamPricing/EditCompetitionSubjectiveExamPricing.jsx";
import AddCompanyDetails from "./components/CompanyDetails/AddCompanyDetails/AddCompanyDetails.jsx";
import AllCompanyDetails from "./components/CompanyDetails/AllCompanyDetails/AllCompanyDetails.jsx";
import EditCompanyDetails from "./components/CompanyDetails/EditCompanyDetails/EditCompanyDetails.jsx";
import AddSchoolPricing from "./components/Pricing/ExamNotesPricing/SchoolPricing/AddSchoolPricing.jsx";
import AllSchoolPricing from "./components/Pricing/ExamNotesPricing/SchoolPricing/AllSchoolPricing.jsx";
import EditSchoolPricing from "./components/Pricing/ExamNotesPricing/SchoolPricing/EditSchoolPricing.jsx";
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import AssignmentPricing from "./components/Pricing/AssignmentPricing/AssignmentPricing.jsx";
import AddNiosAssignmentPricing from "./components/Pricing/AssignmentPricing/NiosAssignmentPricing/AddNiosAssignmentPricing.jsx";
import AllNiosAssignmentPricing from "./components/Pricing/AssignmentPricing/NiosAssignmentPricing/AllNiosAssignmentPricing.jsx";
import EditNiosAssignmentPricing from "./components/Pricing/AssignmentPricing/NiosAssignmentPricing/EditNiosAssignmentPricing.jsx";
import AddUniversityAssignmentPricing from "./components/Pricing/AssignmentPricing/UniversityAssignmentPricing/AddUniversityAssignmentPricing.jsx";
import AllUniversityAssignmentPricing from "./components/Pricing/AssignmentPricing/UniversityAssignmentPricing/AllUniversityAssignmentPricing.jsx";
import EditUniversityAssignmentPricing from "./components/Pricing/AssignmentPricing/UniversityAssignmentPricing/EditUniversityAssignmentPricing.jsx";
import AddHomeTutorPricing from "./components/Pricing/HomeTutorPricing/AddHomeTutorPricing.jsx";
import AllHomeTutorPricing from "./components/Pricing/HomeTutorPricing/AllHomeTutorPricing.jsx";
import EditHomeTutorPricing from "./components/Pricing/HomeTutorPricing/EditHomeTutorPricing.jsx";
import AddCategory from "./components/School/Category/AddCategory.jsx";
import AllCategory from "./components/School/Category/AllCategory.jsx";
import EditCategory from "./components/School/Category/EditCategory.jsx";
import AddOtherNotes from "./components/Student/ExamNotes/UploadNotes/other/AddOtherNotes.jsx";
import AllOtherNotes from "./components/Student/ExamNotes/UploadNotes/other/AllOtherNotes.jsx";
import EditOtherNotes from "./components/Student/ExamNotes/UploadNotes/other/EditOtherNotes.jsx";
import AddCategoryTopic from "./components/School/CategoryTopic/AddCategoryTopic.jsx";
import AllCategoryTopic from "./components/School/CategoryTopic/AllCategoryTopic.jsx";
import EditCategoryTopic from "./components/School/CategoryTopic/EditCategoryTopic.jsx";
import International from "./components/Student/StudentScholarship/InternationalScholarship/International.jsx";
import AllInternationalScholarship from "./components/Student/StudentScholarship/InternationalScholarship/AllInternationalScholarship/AllInternationalScholarship.jsx";
import EditInternationalScholarship from "./components/Student/StudentScholarship/InternationalScholarship/EditInternationalScholarship/EditInternationalScholarship.jsx";
import AddOtherPricing from "./components/Pricing/ExamNotesPricing/OtherPricing/AddOtherPricing.jsx";
import AllOtherPricing from "./components/Pricing/ExamNotesPricing/OtherPricing/AllOtherPricing.jsx";
import EditOtherPricing from "./components/Pricing/ExamNotesPricing/OtherPricing/EditOtherPricing.jsx";
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import AddBoard from "./components/School/SchoolBoards/SchoolAddboard/AddBoard.jsx";
import ManageJobs from "./components/Student/Job/Job.jsx";
import TeacherAssignSubjective from "./components/Teacher/TeacherAssignSubjective.jsx";
import AppointmentList from "./components/Student/Appointment.js";
// import Appointment from "../../path4u-backend/models/Common/bookAppointment.model.js";

import useDeviceCheck from "./hooks/useDeviceCheck";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { useEffect, useState } from "react";
import ChangePassword from "./components/Settings/ChangePassword.js";
import CurrentAffairs from "./components/currentAffairs/currentaffairs.js";
import LiveClassSession from "./components/LiveClasses/LiveClassSession/LiveClassSession.jsx";
import Updates from "./components/updates/Updates.jsx";
function App() {
  // const isAuthenticated = Boolean(localStorage.getItem("token"));
  // console.log(isAuthenticated);

  const isAuthenticated = Boolean(localStorage.getItem("token"));
  const [deviceId, setDeviceId] = useState("");

  useEffect(() => {
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setDeviceId(result.visitorId);
    };
    loadFingerprint();
  }, []);
  // ⭐ device check
  
  useDeviceCheck(deviceId);

  return (
    <div className="App">
      {/* <Router> */}
        <Routes>
          {!isAuthenticated ? (
            <Route path="/" element={<Login />} />
          ) : (
            <>
              <Route path="/logout" element={<Logout />} />
              <Route element={<CommonLayout />}>
                {/* <Route
                  path="/"
                  element={
                    <h4 className="w-100 d-flex justify-content-center align-items-center vh-100">
                      Path4U Admin Dashboard
                    </h4>
                  }
                /> */}
                <Route path="/" element={<Dashboard />} />

                {/* school routes */}
                <Route path={"school-add-class"} element={<SchoolAddClass />} />
                <Route
                  path={"school-edit-class/:id"}
                  element={<SchoolEditClass />}
                />
                <Route path={"school-all-class"} element={<SchoolAllClass />} />
                <Route path={"school-add-board"} element={<AddBoard />} />
                <Route
                  path={"school-add-subject"}
                  element={<SchoolAddSubject />}
                />
                <Route
                  path={"school-all-subject"}
                  element={<SchoolAllSubject />}
                />
                <Route
                  path="/school-edit-subject/:id"
                  element={<SchoolEditSubject />}
                />
                <Route
                  path={"school-add-chapter"}
                  element={<SchoolChapter />}
                />
                <Route
                  path={"school-all-chapter"}
                  element={<SchoolAllChapter />}
                />

                {/* college routes  */}
                <Route
                  path={"college-add-course"}
                  element={<UniversityCourse />}
                />
                <Route path={"university-add"} element={<UniversityAdd />} />
                <Route
                  path={"university-all"}
                  element={<UniversityAllList />}
                />
                <Route
                  path={"college-all-courses"}
                  element={<UniversityAllCourse />}
                />
                <Route
                  path={"college-subject"}
                  element={<UniversitySubjectCreate />}
                />
                <Route
                  path={"college-all-subject"}
                  element={<UniversitySubjectTable />}
                />
                <Route
                  path={"college-semester"}
                  element={<UniversitySemesterCreate />}
                />
                <Route
                  path={"college-semester-table"}
                  element={<UniversitySemesterTable />}
                />

                <Route
                  path="/university-edit/:id"
                  element={<UniversityEdit />}
                />
                <Route
                  path="/university-edit-course/:id"
                  element={<UniversityEditCourse />}
                />
                <Route
                  path="/university-edit-semester/:id"
                  element={<UniversitySemesterEdit />}
                />
                <Route
                  path="/university-subject-edit/:id"
                  element={<UniversitySubjectEdit />}
                />

                {/* competitive exam routes  */}
                <Route
                  path={"ce-exam-add-category"}
                  element={<CEAddExamCategory />}
                />
                <Route
                  path={"ce-exam-all-category"}
                  element={<CEAllExamCategory />}
                />
                <Route
                  path={"ce-add-subject"}
                  element={<CEAddCompetitiveSubject />}
                />
                <Route
                  path={"ce-all-subject"}
                  element={<CEAllCompetitiveSubject />}
                />
                <Route path={"ce-add-topic"} element={<CEAddTopics />} />
                <Route path={"ce-all-topic"} element={<CEAllTopics />} />
                <Route
                  path="/edit-exam-category/:id"
                  element={<EditExamCategory />}
                />
                <Route
                  path="/edit-competitive-subject/:id"
                  element={<EditCompetitiveSubject />}
                />

                {/* Exam Notes -> All Notes  */}
                <Route path={"exam-all-notes"} element={<StudentAllNotes />} />
                <Route
                  path={"exam-course-management"}
                  element={<CourseManagement />}
                />
                <Route
                  path={"exam-upload-notes"}
                  element={<UniversitySemesterTable />}
                />

                <Route path={"settings"} element={<Path4uSettings />} />
                <Route path={"current_affairs"} element={<CurrentAffairs />} />
                <Route path={"updates"} element={<Updates />} />

                {/* ////  */}
                {/* <Route
                  path={"upload-notes/upload-competitive-notes"}
                  element={<UploadAddCompetitiveNotes />}
                /> */}
                {/* Home Work Assistance  */}

                {/* <Route
              path={"home-work-assistance/course-management"}
              element={<CourseManagement />}
            />
            <Route path={"student-profile"} element={<StudentsProfile />} />
            <Route path={"teacher-profile"} element={<TeachersProfile />} /> */}

                {/* States  */}
                <Route path={"create-state"} element={<State />} />
                <Route path="/edit-state/:id" element={<EditState />} />
                <Route path={"all-states"} element={<AllStates />} />
                {/* Cities */}
                <Route path={"create-city"} element={<City />} />
                <Route path={"all-cities"} element={<AllCity />} />
                <Route path="/edit-city/:id" element={<EditCity />} />

                {/* govt. approve council  */}
                <Route
                  path={"government-approved-council"}
                  element={<GovApprovedCouncil />}
                />
                <Route
                  path={"all-government-approved-council"}
                  element={<AllGovApprovedCouncil />}
                />
                <Route
                  path={"edit-government-approved-council/:id"}
                  element={<EditGovApprovedCouncil />}
                />

                {/* student profile  */}
                <Route path={"student-profile"} element={<StudentsProfile />} />
                <Route
                  path={"student-profile/student-profile-details"}
                  element={<StudentsProfileDetails />}
                />
                <Route path={"teacher-profile"} element={<TeachersProfile />} />
                <Route
                  path={"/teacher-profile-details/:id"}
                  element={<TeachersProfileDetails />}
                />

                {/* sliders  */}
                <Route path="/add-sliders" element={<SlidersAdd />} />
                <Route path="/all-sliders" element={<SlidersAll />} />
                <Route path="/edit-sliders/:id" element={<SlidersEdit />} />

                {/* assignment nios and university */}

                <Route path="/nios-add-class" element={<NiosNewClass />} />
                <Route path="/nios-all-class" element={<NiosAllClass />} />
                <Route
                  path="/nios-edit-class/:id"
                  element={<NiosEditClass />}
                />

                <Route path="/nios-add-subject" element={<NiosAddSubject />} />
                <Route path="/nios-all-subject" element={<NiosAllSubject />} />
                <Route
                  path="/nios-edit-subject/:id"
                  element={<NiosEditSubject />}
                />

                {/* Offer and Coupons route  */}
                <Route path="/add-coupons" element={<AddCoupons />} />
                <Route path="/all-coupons" element={<AllCoupons />} />
                <Route path="/edit-coupons/:id" element={<EditCoupons />} />

                {/* pricing routes  */}
                {/* appointment Pricing */}
                <Route
                  path="/add-appointment-pricing"
                  element={<AddAppointmentPricing />}
                />
                <Route
                  path="/all-appointment-pricing"
                  element={<AllAppointmentPricing />}
                />

                <Route
                  path="/all-appointment"
                  element={<AppointmentList />}
                />
                <Route
                  path="/edit-appointment-pricing/:id"
                  element={<EditAppointmentPricing />}
                />
                {/* Wallet Pricing */}
                <Route
                  path="/add-wallet-pricing"
                  element={<AddWalletPricing />}
                />
                <Route
                  path="/all-wallet-pricing"
                  element={<AllWalletPricing />}
                />
                <Route
                  path="edit-wallet-pricing/:id"
                  element={<EditWalletPricing />}
                />

                {/* Home Work Pricing */}
                <Route
                  path="/add-home-work-pricing"
                  element={<AddHomeWorkPricing />}
                />
                <Route
                  path="/all-home-work-pricing"
                  element={<AllHomeWorkPricing />}
                />
                <Route
                  path="/edit-home-work-pricing/:id"
                  element={<EditHomeWorkPricing />}
                />

                {/* Exam Notes Pricing */}

                <Route
                  path="/exam-notes-pricing"
                  element={<ExamNotesPricing />}
                />
                {/* Exam Notes Nios Pricing */}
                <Route
                  path="/exam-notes-pricing/add-nios-pricing"
                  element={<AddNiosPricing />}
                />
                <Route
                  path="/exam-notes-pricing/all-nios-pricing"
                  element={<AllNiosPricing />}
                />
                <Route
                  path="/exam-notes-pricing/edit-nios-pricing/:id"
                  element={<EditNiosPricing />}
                />
                {/* Exam Notes university Pricing */}
                <Route
                  path="/exam-notes-pricing/add-university-pricing"
                  element={<AddUniversityPricing />}
                />
                <Route
                  path="/exam-notes-pricing/all-university-pricing"
                  element={<AllUniversityPricing />}
                />
                <Route
                  path="/exam-notes-pricing/edit-university-pricing/:id"
                  element={<EditUniversityPricing />}
                />
                {/* Exam Notes Competition Pricing */}
                <Route
                  path="/exam-notes-pricing/add-competition-pricing"
                  element={<AddCompetitionPricing />}
                />
                <Route
                  path="/exam-notes-pricing/all-competition-pricing"
                  element={<AllCompetitionPricing />}
                />
                <Route
                  path="/exam-notes-pricing/edit-competition-pricing/:id"
                  element={<EditCompetitionPricing />}
                />

                {/* Exam Notes School Pricing */}
                <Route
                  path="/exam-notes-pricing/add-school-pricing"
                  element={<AddSchoolPricing />}
                />
                <Route
                  path="/exam-notes-pricing/all-school-pricing"
                  element={<AllSchoolPricing />}
                />
                <Route
                  path="/exam-notes-pricing/edit-school-pricing/:id"
                  element={<EditSchoolPricing />}
                />
                {/* Other notes pricing */}

                <Route
                  path="/exam-notes-pricing/add-other-pricing"
                  element={<AddOtherPricing />}
                />
                <Route
                  path="/exam-notes-pricing/all-other-pricing"
                  element={<AllOtherPricing />}
                />
                <Route
                  path="/exam-notes-pricing/edit-other-pricing/:id"
                  element={<EditOtherPricing />}
                />
                {/* ----------------------------------------------------------------------- */}
                {/* Subjective Exam Pricing Route */}
                <Route
                  path="/subjective-exam-pricing"
                  element={<SubjectiveExamPricing />}
                />
                <Route
                  path="/subjective-teacher-assigning"
                  element={<TeacherAssignSubjective />}
                />
                {/* school subjective exam pricing route */}
                <Route
                  path="/subjective-exam-pricing/add-school-subjective-exam-pricing"
                  element={<AddSchoolSubjectiveExamPricing />}
                />
                <Route
                  path="/subjective-exam-pricing/all-school-subjective-exam-pricing"
                  element={<AllSchoolSubjectiveExamPricing />}
                />
                <Route
                  path="/subjective-exam-pricing/edit-school-subjective-exam-pricing/:id"
                  element={<EditSchoolSubjectiveExamPricing />}
                />

                {/* university subjective exam pricing route */}
                <Route
                  path="/subjective-exam-pricing/add-university-subjective-exam-pricing"
                  element={<AddUniversitySubjectiveExamPricing />}
                />
                <Route
                  path="/subjective-exam-pricing/all-university-subjective-exam-pricing"
                  element={<AllUniversitySubjectiveExamPricing />}
                />
                <Route
                  path="/subjective-exam-pricing/edit-university-subjective-exam-pricing/:id"
                  element={<EditUniversitySubjectiveExamPricing />}
                />

                {/* competition subjective exam pricing route */}
                <Route
                  path="/subjective-exam-pricing/add-competition-subjective-exam-pricing"
                  element={<AddCompetitionSubjectiveExamPricing />}
                />
                <Route
                  path="/subjective-exam-pricing/all-competition-subjective-exam-pricing"
                  element={<AllCompetitionSubjectiveExamPricing />}
                />
                <Route
                  path="/subjective-exam-pricing/edit-competition-subjective-exam-pricing/:id"
                  element={<EditCompetitionSubjectiveExamPricing />}
                />

                {/* company details route */}
                <Route
                  path="/add-company-details"
                  element={<AddCompanyDetails />}
                />
                <Route
                  path="/all-company-details"
                  element={<AllCompanyDetails />}
                />
                <Route
                  path="/edit-company-details/:id"
                  element={<EditCompanyDetails />}
                />

                {/* Assignment Pricing */}

                <Route
                  path="/assignment-pricing"
                  element={<AssignmentPricing />}
                />
                {/* nios assignment pricing route */}
                <Route
                  path="/assignment-pricing/add-nios-assignment-pricing"
                  element={<AddNiosAssignmentPricing />}
                />
                <Route
                  path="/assignment-pricing/all-nios-assignment-pricing"
                  element={<AllNiosAssignmentPricing />}
                />
                <Route
                  path="/assignment-pricing/edit-nios-assignment-pricing/:id"
                  element={<EditNiosAssignmentPricing />}
                />
                {/* university assignment pricing route */}
                <Route
                  path="/assignment-pricing/add-university-assignment-pricing"
                  element={<AddUniversityAssignmentPricing />}
                />
                <Route
                  path="/assignment-pricing/all-university-assignment-pricing"
                  element={<AllUniversityAssignmentPricing />}
                />
                <Route
                  path="/assignment-pricing/edit-university-assignment-pricing/:id"
                  element={<EditUniversityAssignmentPricing />}
                />

                {/* Home Tutor Pricing */}
                <Route
                  path="/add-home-tutor-pricing"
                  element={<AddHomeTutorPricing />}
                />
                <Route
                  path="/all-home-tutor-pricing"
                  element={<AllHomeTutorPricing />}
                />
                <Route
                  path="/edit-home-tutor-pricing/:id"
                  element={<EditHomeTutorPricing />}
                />
                {/* Category route */}
                <Route path="/add-category" element={<AddCategory />} />
                <Route path="/all-category" element={<AllCategory />} />
                <Route path="/edit-category/:id" element={<EditCategory />} />
                {/* Category topic route */}
                <Route
                  path="/add-category-topic"
                  element={<AddCategoryTopic />}
                />
                <Route
                  path="/all-category-topic"
                  element={<AllCategoryTopic />}
                />
                <Route
                  path="/edit-category-topic/:id"
                  element={<EditCategoryTopic />}
                />

                {/* subadmin routes start */}
                {/* ------------------------------------------------------------------------------------------------- */}
                {/* Enum for subadmin -> Assignment */}
                {/* -------------------- Student Assignment -------------------  */}
                <Route path={"student-assignment"} element={<Assignment />} />
                <Route
                  path={"/student-assignment/school"}
                  element={<AssignmentSchool />}
                />
                <Route
                  path={"student-assignment/all-school"}
                  element={<AllAssignmentSchool />}
                />
                <Route
                  path="/student-assignment/edit-school/:id"
                  element={<EditAssignmentSchool />}
                />
                <Route
                  path={"/student-assignment/university"}
                  element={<AssignmentUniversity />}
                />

                <Route
                  path={"student-assignment/all-university"}
                  element={<AllAssignmentUniversity />}
                />
                <Route
                  path="/student-assignment/edit-university/:id"
                  element={<EditAssignmentUniversity />}
                />

                {/* ----------------------------------------------------------------- */}
                {/* Enum for subadmin -> Subjective_Exam */}
                {/*------------------------- Subjective Exam ------------------ */}
                <Route
                  path={"student-subjective-exam"}
                  element={<SubjectiveExam />}
                />

                {/* School SE Routes */}
                <Route
                  path={"student-subjective-exam/school-se"}
                  element={<SchoolSE />}
                />
                <Route
                  path={
                    "student-subjective-exam/school-se/approval-uploaded-exam"
                  }
                  element={<SApprovalUE />}
                />
                <Route
                  path={
                    "student-subjective-exam/school-se/approval-submitted-exam"
                  }
                  element={<SApprovalSMTE />}
                />
                <Route
                  path={
                    "student-subjective-exam/school-se/approval-checked-exam"
                  }
                  element={<SApprovalCE />}
                />

                {/* University SE Routes */}
                <Route
                  path={"student-subjective-exam/university-se"}
                  element={<UniversitySE />}
                />
                <Route
                  path={
                    "student-subjective-exam/university-se/approval-uploaded-exam"
                  }
                  element={<UApprovalUE />}
                />
                <Route
                  path={
                    "student-subjective-exam/university-se/approval-submitted-exam"
                  }
                  element={<UApprovalSMTE />}
                />
                <Route
                  path={
                    "student-subjective-exam/university-se/approval-checked-exam"
                  }
                  element={<UApprovalCE />}
                />

                {/* CompetitiveExam SE  */}
                <Route
                  path={"student-subjective-exam/compititive-exam-se"}
                  element={<CompExamSE />}
                />
                <Route
                  path={
                    "student-subjective-exam/compititive-subjective-exam/approval-uploaded-exam"
                  }
                  element={<CApprovalUE />}
                />
                <Route
                  path={
                    "student-subjective-exam/compititive-subjective-exam/approval-submitted-exam"
                  }
                  element={<CApprovalSMTE />}
                />
                <Route
                  path={
                    "student-subjective-exam/compititive-subjective-exam/approval-checked-exam"
                  }
                  element={<CApprovalCE />}
                />



                {/* ---------------------- exam notes route------------------------------------ */}
                {/* Enum for subadmin -> Exam_Notes */}
                {/* Exam Notes route */}

                <Route
                  path={"upload-notes/upload-all-notes"}
                  element={<UploadAllNotes />}
                />
                {/* school notes route */}
                <Route
                  path={"upload-notes/upload-school-notes"}
                  element={<UploadSchoolNotes />}
                />
                <Route
                  path={"upload-notes/all-school-notes"}
                  element={<UploadAllSchoolNotes />}
                />
                <Route
                  path="/upload-notes/edit-school-notes/:id"
                  element={<EditSchoolNotes />}
                />
                {/* university notes route */}
                <Route
                  path={"upload-notes/upload-add-university-notes"}
                  element={<UploadAddCollegeNotes />}
                />
                <Route
                  path={"upload-notes/upload-all-university-notes"}
                  element={<UploadAllCollegeNotes />}
                />
                <Route
                  path="/upload-notes/edit-college-notes/:id"
                  element={<EditCollegeNotes />}
                />
                {/* competitive notes route */}
                <Route
                  path={"upload-notes/upload-add-competitive-notes"}
                  element={<UploadAddCompetitiveNotes />}
                />
                <Route
                  path={"upload-notes/upload-all-competitive-notes"}
                  element={<UploadCompetitiveNotes />}
                />
                <Route
                  path="/upload-notes/edit-competitive-notes/:id"
                  element={<EditCompetitiveNotes />}
                />

                {/* nios notes route */}
                <Route
                  path="/upload-notes/add-nios-notes"
                  element={<AddNiosNotes />}
                />
                <Route
                  path="/upload-notes/all-nios-notes"
                  element={<AllNiosNotes />}
                />
                <Route
                  path="/upload-notes/edit-nios-notes/:id"
                  element={<EditNiosNotes />}
                />
                {/* other notes other */}
                <Route
                  path="/upload-notes/add-other-notes"
                  element={<AddOtherNotes />}
                />
                <Route
                  path="/upload-notes/all-other-notes"
                  element={<AllOtherNotes />}
                />
                <Route
                  path="/upload-notes/edit-other-notes/:id"
                  element={<EditOtherNotes />}
                />
                {/* ---------------------------- Home Tutor route ---------------------------------------- */}
                {/* Enum for subadmin -> Home_Tutor */}
                {/* Home Tutor  */}
                <Route
                  path={"home-tutor/course-management"}
                  element={<HomeTutorCourseManagement />}
                />
                <Route
                  path={"home-tutor/tuition-management-system"}
                  element={<HomeTutorTuitionManagementSystem />}
                />
                <Route
                  path={"home-tutor/tuition-management-system/tms-share/:id"}
                  element={<TMSshare />}
                />
                <Route
                  path={
                    "home-tutor/tuition-management-system/home-tutor/tuition-management-system/tms-share/student-all-details"
                  }
                  element={<TMSshare />}
                />
                <Route
                  path={
                    "home-tutor/tuition-management-system/tms-share/student-all-details"
                  }
                  element={<StudentAllDetails />}
                />
                {/* ------------------------ home work assistance route ----------------------------------- */}
                {/* Enum for subadmin -> HW_Assistance */}
                <Route
                  path={"home-work-assistance/student-hw-list"}
                  element={<StudentHomeWorkDetails />}
                />
                <Route
                  path="/home-work-assistance/teacher-assign/:hwId"
                  element={<TeacherAssign />}
                />

                <Route
                  path="/home-work-assistance/solution-hw-list"
                  element={<SolutionHomeWork />}
                />
                {/* ---------------------------- live classes route ------------------------------------ */}
                {/* Enum for subadmin -> Live_Classes */}
                {/* live classes  */}
                <Route path="/live-class-add" element={<LiveClassAdd />} />
                <Route path="/live-class-list" element={<LiveClassAll />} />
                <Route path="/live-class-session" element={<LiveClassSession />} />
                

                <Route
                  path="/live-class-purchase"
                  element={<LiveClassesPurchase />}
                />
                <Route
                  path="/live-class-detail/:liveClassId"
                  element={<LiveClassDetail />}
                />
                <Route
                  path="/live-class-edit/:editId"
                  element={<LiveClassEdit />}
                />
                {/* ----------------------- student scholarship route ----------------------------- */}
                {/* Enum for subadmin -> Scholarship */}
                {/* student scholarship */}
                <Route
                  path={"student-scholarship"}
                  element={<StudentScholarship />}
                />
                <Route
                  path={"student-scholarship/central-government"}
                  element={<CentalGovScholarship />}
                />
                <Route
                  path={"student-scholarship/state-government"}
                  element={<StateGovScholarship />}
                />
                <Route
                  path="student-scholarship/international-scholarship"
                  element={<International />}
                />
                <Route
                  path="/student-scholarship/all-international-scholarship"
                  element={<AllInternationalScholarship />}
                />
                <Route
                  path={"student-scholarship/private-scholarship"}
                  element={<NGOPrivateGovScholarship />}
                />
                <Route
                  path={"student-scholarship/all-central-government"}
                  element={<AllCentalGovScholarship />}
                />
                <Route
                  path={"student-scholarship/all-state-government"}
                  element={<AllStateGovScholarship />}
                />
                <Route
                  path={"student-scholarship/all-private-scholarship"}
                  element={<AllNGOPrivateGovScholarship />}
                />
                <Route
                  path="/student-scholarship/edit-state-gov-scholarship/:id"
                  element={<EditStateGovScholarship />}
                />
                <Route
                  path="/student-scholarship/edit-private-scholarship/:id"
                  element={<EditNGOPrivateScholarship />}
                />
                <Route
                  path="/student-scholarship/edit-central-gov-scholarship/:id"
                  element={<EditCentralGovScholarship />}
                />
                <Route
                  path="/student-scholarship/edit-international-scholarship/:id"
                  element={<EditInternationalScholarship />}
                />

                <Route
                  path="/job"
                  element={<ManageJobs />}
                />
                {/* ----------------------- Notification Route -------------------------------------- */}
                {/* Enum for subadmin -> Notification */}
                {/* Push Notification */}
                <Route
                  path={"push-notification"}
                  element={<PushNotification />}
                />
                <Route
                  path={"all-push-notification"}
                  element={<AllPushNotification />}
                />
                <Route
                  path={"edit-push-notification/:id"}
                  element={<EditPushNotification />}
                />
                
                
                {/* ----------------------------- Choose Career -------------------------------- */}
                {/* Enum for subadmin -> Choose_Career */}
                {/* Choose Career*/}
                <Route path="/management" element={<ChooseCareer />} />
                <Route path="/changepass" element={<ChangePassword />} />
                <Route path="/add-career" element={<CareerAdd />} />
                <Route path="/all-career" element={<CareerAll />} />
                <Route path="/edit-career/:id" element={<CareerEdit />} />
                <Route path="/add-blog" element={<BlogAdd />} />
                <Route path="/all-blog" element={<BlogAll />} />
                <Route path="/edit-blog/:blogId" element={<BlogEdit />} />
                {/* ------------------------------------------------------------------- */}
              </Route>
            </>
          )}
        </Routes>
      {/* </Router> */}
      <ToastContainer />
    </div>
  );
}

export default App;
